import { render } from "./Workspace.vue?vue&type=template&id=05ca8943&scoped=true&ts=true"
import script from "./Workspace.vue?vue&type=script&lang=ts"
export * from "./Workspace.vue?vue&type=script&lang=ts"

import "./Workspace.vue?vue&type=style&index=0&id=05ca8943&lang=scss&scoped=true"

import exportComponent from "/opt/pptcopilot/app/ppt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ca8943"]])

export default __exports__